import { forwardRef, useState } from "react";
import InputFieldWithIcon from "../../components/GInput/Input";
import i18n from "../../lib/i18n";

const ConfirmRecord = forwardRef(({loadingConfirm, handelConfirm, closeConfirmation}, ref) => {
    
    const [value, setValue] = useState("");
    const [isFocused, setIsFocused] = useState(false);
    const t = i18n.t.bind(i18n); 

    const onchange = (e) => {
        setValue(e.target.value)
    }

    const suggestions = [
      t("order_suggestion.incomplete"),
      t("order_suggestion.incorrect"),
      t("order_suggestion.time"),
      t("order_suggestion.other"),
    ];
    
        return(
    <div
    //   role="dialog"
    //   aria-label="تأكيد العملية"
    //   aria-modal="true"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
    >
      
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-md w-full mx-4 p-6 md:p-7" ref={ref}>
        <div className="relative">
          <button type="button" onClick={closeConfirmation} className="absolute top-[-20px] left-0 text-white text-[26px] hover:text-danger">
              x
          </button>
        </div>
        <h2 className="text-xl md:text-2xl text-center font-semibold mt-1 mb-4 text-gray-800 dark:text-white">
          {t("order.confirm_operation")}
        </h2>
        <p className="mb-6 text-sm md:text-base text-gray-600 dark:text-gray-200">
          {t("order.please_confirm_or_reject")}
        </p>

        <div className="mb-6">
          <input
            type="text"
            value={value}
            onChange={onchange}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setTimeout(() => setIsFocused(false), 200)} 
            placeholder={t("order.reject_reson")}
            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />

          {isFocused && (
            <ul className=" left-0 right-0 bg-white border border-gray-300 rounded mt-1 max-h-40 overflow-y-auto scrollSuggestion z-10">
              {suggestions
                .filter((s) =>
                  value ? s.includes(value) : true // show all when empty
                )
                .map((s, i) => (
                  <li
                    key={i}
                    onClick={() => {
                      setValue(s);
                      setIsFocused(false);
                    }}
                    className="px-3 py-2 cursor-pointer hover:bg-gray-100"
                  >
                    {s}
                  </li>
                ))}
            </ul>
          )}
        </div>

        <div className="flex items-center justify-between gap-3">

          <button
            type="button"
            onClick={() => handelConfirm("REJECT", value)}
            disabled={loadingConfirm}
            className="flex-1 min-w-[120px] bg-red-600 hover:bg-red-700 text-white text-sm px-4 py-2 rounded"
            // aria-disabled={loadingConfirm}
          >
            {loadingConfirm ? (
              <span className="inline-flex items-center justify-center">
                <span className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent mt-1" />
              </span>
            ) : (
              t("order.reject")
            )}
          </button>
          <button
            type="button"
            onClick={() => handelConfirm("CONFIRM")}
            disabled={loadingConfirm}
            className="flex-1 min-w-[120px] bg-green-600 hover:bg-green-700 text-white text-sm px-4 py-2 rounded"
            // aria-disabled={loadingConfirm}
          >
            {loadingConfirm ? (
              <span className="inline-flex items-center justify-center">
                <span className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent mt-1" />
              </span>
            ) : (
              t("order.confirm")
            )}
          </button>

        </div>
      </div>
    </div>
        );
});

export default ConfirmRecord;

